export function Definitions() {
  return (
    <p>
      The data protection declaration of City Falcon Limited is based on the terms used by the European legislator for the adoption of the
      {' '}
      <a href="https://gdpr-info.eu/" target="_blank" rel="noopener noreferrer"> General Data Protection Regulation</a>
      {' '}
      (GDPR). Our data protection declaration should be legible and understandable for the general public, as well as our customers and business partners. To ensure this, we would like to first explain the terminology used.
      <br />
      <br />
      In this data protection declaration, we use, inter alia, the following terms:
      <br />
      <br />
      a) Personal data
      <br />
      Personal data means any information relating to an identified or identifiable natural person (“data subject”).An identifiable natural person is one who can be identified, directly or indirectly, in particular by reference to an identifier such as a name, an identification number, location data, an online identifier or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity of that natural person.
      <br />
      <br />
      b) Data subject
      <br />
      Data subject is any identified or identifiable natural person, whose personal data is processed by the controller responsible for the processing.
    </p>
  );
}

export default Definitions;
